import $ from 'jquery';
import initSelect2 from 'linksoft-select2';

export default function () {
    $('#measurementTypeSelect select').on('change', function () {
        const $select = $(this); 
        const typeId = $select.val();
        const preselectedValue = $select.data('preselected-value');

        if(typeId == preselectedValue){
            // only localization changed visible text
            return;
        }
        
        $('#measurementTypeParameterSelect select').val(null).trigger('change');
        $('#measurementTypeParameterSelect select').attr("data-odata-filter", "measurementTypeId eq " + typeId);
    });
}


// WEBPACK FOOTER //
// ./App/components/modules/measurementTypeParameterSelect.js